import { useEffect, useRef } from 'react';
import Image from 'next/image';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import cn from 'classnames';

gsap.registerPlugin(ScrollTrigger);

const TituloIlustracion = ({
  fontTitle = '!text-27 sm:!text-48',
  svgRoundedLine = '',
  titleMargin = 'mb-50 sm:mb-115'
}) => {
  const root = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      '.things-js',
      {
        scale: 0,
        rotate: '-90deg'
      },
      {
        scrollTrigger: {
          trigger: root.current,
          start: 'top+=10% center'
        },
        scale: 1,
        rotate: 0,
        ease: 'back.out'
      }
    );
    gsap.fromTo(
      '.title-faqs-js',
      {
        autoAlpha: 0,
        y: 15
      },
      {
        scrollTrigger: {
          trigger: root.current,
          start: 'top-=20% center'
        },
        autoAlpha: 1,
        y: 0
      }
    );
  }, []);

  return (
    <div
      ref={root}
      className={cn('flex flex-col sm:flex-row items-start sm:items-center', titleMargin)}
    >
      <div className="relative w-190 sm:w-220 aspect-[220/330]">
        <Image
          src="/images/preguntas/chica.svg"
          width={220}
          height={330}
          alt=""
          className="w-150 sm:w-full object-cover"
        />
        <Image
          src="/images/preguntas/things.svg"
          width={50}
          height={57}
          alt=""
          className="absolute z-1 top-[-7%] right-[15%] sm:top-0 sm:right-8 origin-bottom-left | things-js"
        />
      </div>
      <div>
        <h2 className={cn('title-2 text-dark-cyan flex sm:flex-col title-faqs-js ', fontTitle)}>
          <div className="mr-10 sm:mr-0 mb-15">Preguntas</div>
          <div className="inline-block relative">
            frecuentes
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <svg
                className={cn('w-215 sm:w-[27.4rem] h-auto', svgRoundedLine)}
                fill="none"
                viewBox="0 0 274 74"
              >
                <rect
                  width="271.902"
                  height="71.902"
                  x="1.049"
                  y="1.049"
                  stroke="url(#paint0_linear_2388_12710)"
                  strokeWidth="2.098"
                  rx="35.951"
                ></rect>
                <defs>
                  <linearGradient
                    id="paint0_linear_2388_12710"
                    x1="310.064"
                    x2="-9.133"
                    y1="0"
                    y2="0"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#EE4424"></stop>
                    <stop offset="0.468" stopColor="#FD813E"></stop>
                    <stop offset="1" stopColor="#22CDC6"></stop>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </h2>
      </div>
    </div>
  );
};
export default TituloIlustracion;
